import { createContext } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';

const CheckOrdersFormContext = createContext<UseFormReturn<FieldValues, any>>({} as UseFormReturn<FieldValues, any>);

export default CheckOrdersFormContext;
